import { render, staticRenderFns } from "./CreateQuotation.vue?vue&type=template&id=53a32c50&scoped=true&"
import script from "./CreateQuotation.vue?vue&type=script&lang=js&"
export * from "./CreateQuotation.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuotation.vue?vue&type=style&index=0&id=53a32c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a32c50",
  null
  
)

export default component.exports